import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";

import s from "./Icon.scss";

import icons from "./icons";

const Icon = ({ icon, color = "currentColor", ...props }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="Icon"
      {...props}
    >
      <path fill={color} d={icons[icon]} />
    </svg>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string
};

export default withStyles(s)(Icon);



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js